import { render, staticRenderFns } from "./menuMultiSelect.vue?vue&type=template&id=061a4baf&scoped=true"
import script from "./menuMultiSelect.vue?vue&type=script&lang=js"
export * from "./menuMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./menuMultiSelect.vue?vue&type=style&index=0&id=061a4baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a4baf",
  null
  
)

export default component.exports